<template>
    <PopupRouterViewDetail label="Vendor Scrap Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Vendor Scrap" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="Code" label-for="input-code" size="sm" :model.sync="model.code"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textarea id="fieldset-address" label-cols-lg="12"  label="Office Address" label-for="input-address" size="sm" :model.sync="model.address"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textbox id="fieldset-contact-person" label-cols-lg="12"  label="Contact Person" label-for="input-contact-person" size="sm" :model.sync="model.contactPerson"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textbox id="fieldset-contact-person-phone-number" label-cols-lg="12"  label="Phone Number" label-for="input-contact-person-phone-number" size="sm" :model.sync="model.contactPersonPhoneNumber"  @change="updateData" :isUpdatable ="true"/>
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import VendorScrap from '@/models/VendorScrap/VendorScrap';
import VendorScrapList from '@/models/VendorScrap/VendorScrapList';
import VendorScrapFilter from '@/filters/VendorScrap/VendorScrapFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterVendorScrap : null,
			currentVendorScrapPage : 1,
			vendorScrapPageSize: 10,
			sortByVendorScrap: '',
			sortDescVendorScrap: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getVendorScrap : async function(id) {
			this.isBusy = true;
			VendorScrap.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadVendorScrap = true;
			this.filterVendorScrap.id = this.modelId;
			VendorScrap.downloadDataDetail(this, this.filterVendorScrap).then(result => {
				this.isDownloadVendorScrap = false;
			}).catch(error => { this.isDownloadVendorScrap = false; })
		},
		getVendorScraps : async function(input) {
			let filter = new VendorScrapFilter();
			if (input != undefined) {
				filter.Code = input;
			}
			this.isVendorScrapComboLoading = true;
			VendorScrap.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendorScraps = result.data
				}
				this.isVendorScrapComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.vendorScrapInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						VendorScrap.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'vendorscrapindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						VendorScrap.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'vendorscrapindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData(state) {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					VendorScrap.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getVendorScrap(id);
					});
				}
			});
		},
		onHidden() {
			this.getVendorScraps();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterVendorScrap = new VendorScrapFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getVendorScrap(id);
			} else {
				this.modelId = id;
				this.getVendorScrap(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
